import {
  Alert,
  Box,
  Button,
  Grid,
  Slide,
  Snackbar,
  Typography,
  Select,
  MenuItem,
  TablePagination,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import ListingsList from "../../../components/seller/reviews/ListingList";
import CustomModal from "../../../components/seller/reviews/Modal";
import DisplayReview from "../../../components/seller/reviews/DisplayReview";
import config from "../../../config";
import { connect } from "react-redux";

let filters = [
  { id: "all", name: "All" },
  { id: "animal", name: "Animal" },
  { id: "service", name: "Service" },
];

const Reviews = ({ classes, seller, jwtToken, user, store }) => {
  const [openDisputeModal, setOpenDisputeModal] = useState(false);
  const [filter, setFilter] = useState(filters[0].id);
  const [confirmProp, setConfirmProp] = useState(false);
  const [confirmProp2, setConfirmProp2] = useState(false);
  const [showReview, setShowReview] = useState(false);
  const [reviewData, setReviewData] = useState();
  const [disputeMessage, setDisputeMessage] = useState();
  const [review, setReview] = useState();
  const [paginationStates, setPaginationStates] = useState({
    page: 0,
    rowsPerPage: 10,
    total_records: 0,
  });
  const [snackbarStates, setSnackbarStates] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const plans = ["Silver", "Free"];
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setDisputeMessage(e.target.value);
  };
  const handleReviewTypeButton = async (type) => {
    setFilter(type);
  };
  const handleOpenDisputeModal = (id) => {
    if (id) {
      setOpenDisputeModal(true);
    }
  };
  const handleCloseDisputeModal = () => {
    setOpenDisputeModal(false);
  };
  const handleCloseNoStoreModal = () => {
    navigate("/seller/profile");
  };
  const fetchSellerReviews = async () => {
    let registerRequest;
    try {
      registerRequest = await axios.get(
        `${config.SERVER_URL}/api/v1/reviews?review_type=${filter}&seller_id=${seller.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
    } catch ({ response }) {
      if (response?.status === 422) {
        console.log("Show error snackbar");
      }
    }

    if (registerRequest && registerRequest.status === 200) {
      const filteredReviews = registerRequest.data.reviews.filter((data) => {
        if (seller?.user?.subscriptions?.[0]?.plan?.name && plans.includes(seller.user.subscriptions[0].plan.name)) {
          if (data.reviewable_type === "ListingAnimal") {
            return data;
          }
        } else {
          return data;
        }
      });
      setReviewData(filteredReviews);
      // setReviewData(registerRequest.data.reviews);
    }
  };

  useEffect(() => {
    if (seller?.user?.subscriptions?.[0]?.plan?.name && plans.includes(seller.user.subscriptions[0].plan.name)) {
      filters = [
        { id: "all", name: "All" },
        { id: "animal", name: "Animal" },
      ];
    }
    if (seller?.id) {
      fetchSellerReviews();
    }
  }, [
    paginationStates.page,
    paginationStates.rowsPerPage,
    seller,
    confirmProp,
    filter,
  ]);

  useEffect(() => {
    const addDispute = async () => {
      let registerRequest;
      try {
        registerRequest = await axios.post(
          `${config.SERVER_URL}/api/v1/reviews/${review.id}/disputes`,
          {
            dispute: {
              description: disputeMessage,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        );
        if (registerRequest.status === 201) {
          setSnackbarStates({
            ...snackbarStates,
            open: true,
            message: "Dispute Added Successfully",
            severity: "success",
          });
        }
      } catch ({ response }) {
        if (response.status === 422) {
          setSnackbarStates({
            ...snackbarStates,
            open: true,
            message: "Dispute already added",
            severity: "error",
          });
        }
      }

      setOpenDisputeModal(false);
      setConfirmProp(false);
      setDisputeMessage("");
    };

    if (confirmProp) {
      addDispute();
    }

    return () => {
      setConfirmProp(false);
    };
  }, [confirmProp]);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarStates({ ...snackbarStates, open: false });
  };

  const onPageChange = (event, newPage) => {
    setPaginationStates({ ...paginationStates, page: newPage });

    const updatedListing = reviewData.slice(
      newPage * paginationStates.rowsPerPage,
      newPage * paginationStates.rowsPerPage + paginationStates.rowsPerPage
    );

    setReviewData(updatedListing);
  };

  const onRowsPerPageChange = (event) => {
    const updatedRowsPerPage = parseInt(event.target.value, 10);
    setPaginationStates({
      ...paginationStates,
      rowsPerPage: updatedRowsPerPage,
      page: 0,
    });

    const updatedRows = reviewData.slice(
      0 * updatedRowsPerPage,
      0 * updatedRowsPerPage + updatedRowsPerPage
    );

    setReviewData(updatedRows);
  };

  const handleCloseReviewModal = () => {
    setShowReview(false);
  };
  const handleNavigateToStore = () => {
    navigate("/seller/profile");
  };
  if (!store) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", minHeight: "60vh", backgroundColor: "#111", gap: 2 }}>
        <Typography sx={{ fontWeight: 800, fontSize: "20px", color: "#fff" }}>Complete Your Seller Profile First</Typography>
        <Typography sx={{ color: "#666", fontSize: "14px" }}>Please complete your seller profile to use the Seller Dashboard.</Typography>
        <Button onClick={handleNavigateToStore} sx={{ px: 4, py: 1, borderRadius: "10px", backgroundColor: "#FFC001", color: "#000", fontWeight: 800, textTransform: "none", "&:hover": { backgroundColor: "#e6ac00" } }}>
          Go to Profile
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, backgroundColor: "#111", minHeight: "100vh" }}>
      <Snackbar transitionDuration={{ enter: 1000, exit: 2000 }} TransitionComponent={Slide} TransitionProps={{ enter: true, exit: false }} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={snackbarStates.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} variant="filled" severity={snackbarStates.severity} sx={{ width: "100%" }}>{snackbarStates.message}</Alert>
      </Snackbar>

      {review && <DisplayReview openModal={showReview} closeModal={handleCloseReviewModal} data={review} />}

      <CustomModal title="Dispute Review" content={""} openModal={openDisputeModal} closeModal={handleCloseDisputeModal} actionTitle={"Submit"} setConfirmProp={setConfirmProp} actionColor={"#FFC001"} showTextBox={true} handleInputChange={handleInputChange} disputeMessage={disputeMessage} />

      {/* Page header */}
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontWeight: 900, fontSize: { xs: "22px", md: "28px" }, color: "#fff", lineHeight: 1.2 }}>
          My <Box component="span" sx={{ color: "#FFC001" }}>Reviews</Box>
        </Typography>
        <Typography sx={{ color: "#555", fontSize: "13px", mt: 0.5 }}>View and dispute customer reviews</Typography>
      </Box>

      {/* Filter bar */}
      <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "12px", px: 2.5, py: 1.5, mb: 2.5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "14px" }}>
          {filters.find(f => f.id === filter)?.name || "All"} Reviews
        </Typography>
        <Select
          value={filter}
          size="small"
          onChange={(e) => handleReviewTypeButton(e.target.value)}
          sx={{ fontSize: "12px", color: "#aaa", height: 32, ".MuiOutlinedInput-notchedOutline": { borderColor: "#333" }, "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#555" }, ".MuiSvgIcon-root": { color: "#555" } }}
        >
          {filters.map((f) => (
            <MenuItem key={f.id} value={f.id} sx={{ fontSize: "13px" }}>{f.name}</MenuItem>
          ))}
        </Select>
      </Box>

      <ListingsList
        handleOpenDisputeModal={handleOpenDisputeModal}
        data={reviewData}
        setOpenDisputeModal={setOpenDisputeModal}
        setReview={setReview}
        setOpenReview={setShowReview}
        page={paginationStates.page}
        rowsPerPage={paginationStates.rowsPerPage}
        classes={classes}
      />

      <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 1 }}>
        <TablePagination
          component="div"
          count={paginationStates.total_records}
          page={paginationStates.page}
          onPageChange={onPageChange}
          rowsPerPage={paginationStates.rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
          sx={{ color: "#ccc", "& .MuiTablePagination-actions button": { color: "#aaa" } }}
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = ({ Categories, Auth, Seller, Store }) => ({
  classes: Categories.classes,
  user: Auth.user,
  seller: Seller.seller,
  jwtToken: Auth.jwtToken,
  store: Store.store,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Reviews);
